module.exports = __webpack_public_path__ + "static/media/mehedi.ecce5f5f.png";